const RETRY_HTTP_STATUS_CODES = [404, 204, 425]
const PENDING_TASK_RESPONSE_KEYS = ['taskId', 'task_id', 'status']
const DEFAULT_INTERVAL_MS = 3000
const DEFAULT_TIMEOUT_MS = 120000

export class PollCancelledError extends Error {
  constructor() {
    super('Poll cancelled')
    this.name = 'PollCancelledError'
  }
}

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

export const isSuggestedCoursesTaskPending = (data, httpStatus) => {
  if (httpStatus === 202) {
    return true
  }

  if (!data || Array.isArray(data)) {
    return false
  }

  const hasTaskId = data.taskId != null || data.task_id != null
  if (!hasTaskId) {
    return false
  }

  const keys = Object.keys(data)
  const isTaskOnlyPayload = keys.length > 0 && keys.every(key => PENDING_TASK_RESPONSE_KEYS.includes(key))

  if (isTaskOnlyPayload) {
    return true
  }

  const status = data.status
  return status === 'pending' || status === 'processing' || status === 'in_progress' || data.ready === false
}

export const parseSuggestedCoursesResponse = (data, httpStatus) => {
  if (isSuggestedCoursesTaskPending(data, httpStatus)) {
    return { ready: false }
  }

  if (Array.isArray(data)) {
    return { ready: true, result: data }
  }

  return { ready: false }
}

export const pollSuggestedCourses = (fetchSuggestedCourses, taskId, options = {}) => {
  const intervalMs = options.intervalMs ?? DEFAULT_INTERVAL_MS
  const timeoutMs = options.timeoutMs ?? DEFAULT_TIMEOUT_MS
  let cancelled = false

  const cancel = () => {
    cancelled = true
  }

  const promise = (async () => {
    const startedAt = Date.now()

    while (Date.now() - startedAt < timeoutMs) {
      if (cancelled) {
        throw new PollCancelledError()
      }

      try {
        const response = await fetchSuggestedCourses({ taskId })
        const { ready, result } = parseSuggestedCoursesResponse(response.data, response.status)

        if (ready) {
          return result
        }
      } catch (error) {
        if (cancelled) {
          throw new PollCancelledError()
        }

        const status = error.response?.status
        if (!status || !RETRY_HTTP_STATUS_CODES.includes(status)) {
          throw error
        }
      }

      await sleep(intervalMs)
    }

    throw new Error('Przekroczono czas oczekiwania na sugerowane kursy')
  })()

  return { promise, cancel }
}
